import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import { NotificationProvider } from "components/ui/NotificationToast";
import NotFound from "pages/NotFound";
import ProjectsManagement from './pages/projects-management';
import ProjectForm from './pages/project-form';
import Login from './pages/login';
import ArticleEditor from './pages/article-editor';
import CitiesManagement from './pages/cities-management';
import Dashboard from './pages/dashboard';
import OfficesManagement from './pages/offices-management';
import ArticlesManagement from './pages/articles-management';
import OfficeForm from './pages/office-form';
import SubUnionForm from './pages/sub-union-form';
import SubUnionsManagement from './pages/sub-unions-management';

const Routes = () => {
  return (
    <BrowserRouter>
      <div dir="rtl">
        <ErrorBoundary>
          <NotificationProvider>
            <ScrollToTop />
            <RouterRoutes>
            {/* Define your route here */}
            <Route path="/" element={<Login />} />
            <Route path="/projects-management" element={<ProjectsManagement />} />
            <Route path="/project-form" element={<ProjectForm />} />
            <Route path="/login" element={<Login />} />
            <Route path="/article-editor" element={<ArticleEditor />} />
            <Route path="/cities-management" element={<CitiesManagement />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/offices-management" element={<OfficesManagement />} />
            <Route path="/articles-management" element={<ArticlesManagement />} />
            <Route path="/office-form" element={<OfficeForm />} />
            <Route path="/office-form/:id" element={<OfficeForm />} />
            <Route path="/sub-union-form" element={<SubUnionForm />} />
            <Route path="/sub-unions-management" element={<SubUnionsManagement />} />
            <Route path="*" element={<NotFound />} />
            </RouterRoutes>
          </NotificationProvider>
        </ErrorBoundary>
      </div>
    </BrowserRouter>
  );
};

export default Routes;